"use strict";

var classnames = require("classnames");
var LoggerInstance = require("js-logger").get("Wizard");

var Select = require("./Select");

var RegExpHelper = require("../designer/RegExpHelper");

var clearAllAnswersFromQuestion = function (model, questionDefinition) {
	delete model[questionDefinition.property];

	if (questionDefinition.answers) {
		if (!Array.isArray(questionDefinition.answers)) {
			// TODO: this should not reach this point, if it does we need a US to investigate
			LoggerInstance.error("handle fetching answers -- clearAnswerNested");
			return;
		}

		if (!questionDefinition.doNotClearNestedAnswers) {
			clearAnswersNested(model, questionDefinition.answers);
		}
	}
}

var clearAnswersNested = function (model, nonSelectedAnswers) {
	nonSelectedAnswers.forEach(nonSelectedAnswer => {
		if (nonSelectedAnswer.questions) {
			nonSelectedAnswer.questions.forEach(questionDefinition => {
				//If this is really a row of questions
				if (questionDefinition.row && questionDefinition.row.questions) {
					questionDefinition.row.questions.forEach(rowQuestionDefinition => {
						clearAllAnswersFromQuestion(model, rowQuestionDefinition);
					});
					return;
				}

				//Otherwise clear the answers for question
				clearAllAnswersFromQuestion(model, questionDefinition);
			});
		}
	});
};

var processDynamicQuestions = function (questionDefinition, answer) {
	if ((typeof questionDefinition.dynamicQuestions === "function")) {
		answer.questions = questionDefinition.dynamicQuestions(answer.value);
	} else if (typeof (questionDefinition.dynamicQuestions) === "string") {
		var dynamicQuestion;
		switch (questionDefinition.dynamicQuestions) {
			case "forEachDescription":
			case "forEachDescriptionAppendPropertyToValue":
			case "forEachShortAndLongDescription":
				var propertyFromQuestion = "";
				if (questionDefinition.dynamicQuestions === "forEachDescriptionAppendPropertyToValue") {
					propertyFromQuestion = `${questionDefinition.property}_`;
				}

				dynamicQuestion = [{
					className: "col-xs-8",
					defaultAnswer: answer.displayValue,
					disabled: (model) => !!model[`${propertyFromQuestion}${answer.value}_Description_Default`],
					property: `${propertyFromQuestion}${answer.value}_Description`,
					question: `${answer.displayValue} Description`
				}, {
					className: "col-xs-4",
					defaultAnswer: true,
					onChange: (model) => {
						if (model[`${propertyFromQuestion}${answer.value}_Description_Default`]) {
							model[`${propertyFromQuestion}${answer.value}_Description`] = answer.displayValue;
						}
					},
					property: `${propertyFromQuestion}${answer.value}_Description_Default`,
					question: "Use Default Description",
					type: "checkbox"
					}];

				answer.className = "row";
				answer.questions = dynamicQuestion;

				if (questionDefinition.dynamicQuestions === "forEachShortAndLongDescription") {
					dynamicQuestion.push({
						className: "col-xs-12",
						property: `${propertyFromQuestion}${answer.value}_LongDescription`,
						question: `${answer.displayValue} Long Description`
					});
					answer.className = "row dynamicQuestionRow";
				}

				break;
			case "subQuestionsShownUponAnswer":
				if (answer && questionDefinition.questions) {
					answer.questions = questionDefinition.questions;
				}
				break;
			default:
				LoggerInstance.error("Unknown dynamicQuestions type while building select.");
				break;
		}
	}
};

var setAnswerNested = function (model, questions, savedModel, stateValues, callback) {
	if (questions) {
		var inactiveDescriptionFetchesRemainingCount = questions.filter(question => question.mustIncludeSelectedAnswer).length;

		questions.forEach(questionDefinition => {
			//If this is really a row of questions
			if (questionDefinition.row && questionDefinition.row.questions) {
				setAnswerNested(model, questionDefinition.row.questions, savedModel, stateValues, callback);
				return;
			}

			//Mark if this needs to be removed from the savedModel
			if (questionDefinition.doNotSaveAnswer) {
				stateValues.doNotSaveProperties.push(questionDefinition.property)
			}

			//Otherwise set the answers for questions
			var defaultAnswer = questionDefinition.defaultAnswer;
			var propertyName = questionDefinition.property;
			var value = model[propertyName];

			if (!model.hasOwnProperty(propertyName) || model[propertyName] === undefined || model[propertyName] === null) {
				if (savedModel && savedModel.hasOwnProperty(propertyName)) {
					value = savedModel[propertyName];
				} else if (defaultAnswer !== null && defaultAnswer !== undefined) {
					value = defaultAnswer;
				} else if (questionDefinition.disallowNull) {
					value = questionDefinition.answers[0].value;
				}

				if (value || value === 0 || value === false) {
					if (questionDefinition.answers) {
						if (questionDefinition.multiple) {
							var validAnswers = questionDefinition.answers.map(a => a.value);
							value = value.filter(v => validAnswers.indexOf(v) !== -1);
						} else if (questionDefinition.answers.findIndex(a => a.value === value) === -1 && !questionDefinition.mustIncludeSelectedAnswer) {
							value = null; // No valid value
						}
					}
					model[propertyName] = value;
				}
			}

			if (questionDefinition.answers) {
				if (!Array.isArray(questionDefinition.answers)) {
					// TODO: this should not reach this point, if it does we need a US to investigate
					LoggerInstance.error("handle fetching answers -- setAnswerNested");
					return;
				}

				var nestedFetchAnswersCallback = () => {
					var selectedAnswers = [];
					if (value) {
						if (questionDefinition.multiple) {
							selectedAnswers = questionDefinition.answers.filter(answer => value.find(val => val == answer.value));
						} else {
							var answer = questionDefinition.answers.find(answer => answer.value == value);
							if (answer) {
								selectedAnswers.push(answer);
							}
						}
					}

					selectedAnswers.forEach(selectedAnswer => {
						processDynamicQuestions(questionDefinition, selectedAnswer);

						if (selectedAnswer.submitText) {
							stateValues.submitText = selectedAnswer.submitText;
						}
						if (selectedAnswer.cancelText) {
							stateValues.cancelText = selectedAnswer.cancelText;
						}
						if (selectedAnswer.hasOwnProperty("canSubmit")) {
							stateValues.canSubmit = selectedAnswer.canSubmit;
						}
						if (selectedAnswer.hasOwnProperty("canCancel")) {
							stateValues.canCancel = selectedAnswer.canCancel;
						}

						// Handle additionalPages from selected answers during initialization
						if (selectedAnswer.additionalPages) {
							stateValues.additionalPages = selectedAnswer.additionalPages;
							stateValues.additionalPageNumber = 0;
						}

						setDynamicQuestionProperty(model, selectedAnswer.questions);
						if (stateValues.loadingInactiveValues && !inactiveDescriptionFetchesRemainingCount) {
							stateValues.loadingInactiveValues = false;
						}
						beginFetchAnswers(model, selectedAnswer.questions, savedModel, stateValues, callback);
					});
				};

				if (questionDefinition.mustIncludeSelectedAnswer) {
					if (!value || questionDefinition.answers.find(answer => answer.value === value)) {
						// We don't need to fetch the description if we already have it
						inactiveDescriptionFetchesRemainingCount--;
						nestedFetchAnswersCallback();
					} else {
						//Try to get the full model of the selected answer, using the selected answer in the url
						var selectedAnswerUrl = questionDefinition.selectedAnswerUrl || (questionDefinition.originalAnswers && questionDefinition.originalAnswers.selectedAnswerUrl);
						$.get({url: RegExpHelper.replaceFirstBraceTokenFromObject(selectedAnswerUrl, model)}, (data) => {
							questionDefinition.answers.unshift({ displayValue: data && data.description ? data.description : value, value: value, label: value });
						}).always(() => {
							inactiveDescriptionFetchesRemainingCount--;
							nestedFetchAnswersCallback();
						});
					}
				} else {
					nestedFetchAnswersCallback();
				}
			}
		});
	}
};

var needToFetchAnswers = function (questions) {
	if (!questions) {
		return false;
	}
	return questions.some(questionDefinition => {
		if (questionDefinition.answers && (!Array.isArray(questionDefinition.answers) || questionDefinition.originalAnswers)) {
			return true;
		} else if (questionDefinition.answers) {
			return questionDefinition.answers.some(answerDefinition => {
				if (!answerDefinition.questions) {
					return false;
				}
				return needToFetchAnswers(answerDefinition.questions);
			});
		} else {
			return false;
		}
	});
};

var needToCheckIfVisible = function (questions) {
	if (!questions) {
		return false;
	}

	return questions.some(questionDefinition => {
		if (questionDefinition.visible && typeof questionDefinition.visible === "object") {
			return true;
		} else if (questionDefinition.answer) {
			return questionDefinition.answers.some(answerDefinition => {
				if (!answerDefinition.questions) {
					return false;
				}
				return needToCheckIfVisible(answerDefinition.questions);
			});
		} else {
			return false;
		}
	});
};

var fetchAnswersForQuestions = function (questions, currentCount, model, callback) {
	questions.forEach(questionDefinition => {
		//If this is really a row of questions
		if (questionDefinition.row && questionDefinition.row.questions) {
			currentCount = fetchAnswersForQuestions(questionDefinition.row.questions, currentCount, model, callback);
			return;
		}

		//Otherwise fetch answers for Questions
		if (questionDefinition.answers && (!Array.isArray(questionDefinition.answers) || questionDefinition.originalAnswers)) {
			++currentCount;
			fetchAnswers(questionDefinition, model, callback);
		} else if (questionDefinition.answers) {
			questionDefinition.answers.forEach(answerDefinition => {
				if (answerDefinition.questions) {
					currentCount = fetchAnswersForQuestions(answerDefinition.questions, currentCount, model, callback);
				}
			});
		}
	});

	return currentCount;
};

var fetchAnswers = function (questionDefinition, model, callback) {
	var answerObject = questionDefinition.originalAnswers || questionDefinition.answers;
	var url = answerObject.url;
	var type = answerObject.type;
	var valueProperty = answerObject.value;
	var displayValueProperty = answerObject.displayValue || valueProperty;
	var displayAlphabetical = answerObject.alphabetical;
	var valuesToHide = answerObject.valuesToHide || [];
	var labelKey = questionDefinition.labelKey;
	var answers = [];

	while (url.indexOf("{") >= 0) {
		questionDefinition.originalAnswers = answerObject;
		//Replacing a URL that looks something like this "/api/countries/{selectedCountry}/states" with the "selectedCountry" value set on the model from a previous question
		url = RegExpHelper.replaceFirstBraceTokenFromObject(url, model);
	}

	while (valueProperty.indexOf("{") >= 0) {
		questionDefinition.originalAnswers = answerObject;
		//Replacing a Value that looks something like this "{selectedCountry}" with the "selectedCountry" value set on the model from a previous question
		valueProperty = RegExpHelper.replaceFirstBraceTokenFromObject(valueProperty, model);
	}

	$.get(url, (data) => {
		switch (type) {
			case "collapseDescription":
				data = processCollapseDescriptionData(data, valueProperty);
				valueProperty = "value";
				displayValueProperty = "description";
				break;
			case "collapseDescriptionAppendPropertyToValue":
				data = processCollapseDescriptionData(data, valueProperty, `${valueProperty}_`);
				valueProperty = "value";
				displayValueProperty = "description";
				break;
			case "childArray":
				if (typeof data === "string") {
					data = JSON.parse(data);
				}
				var childName = answerObject.childName;
				data = data[childName];
				break;
			case "paging":
				// TODO: enhance paging to handle multiple pages
				data = data.items;
				break;
		}

		if (answerObject.staticEntries && answerObject.staticEntries.length) {
			answers.push(...answerObject.staticEntries);
		}

		data.forEach((dataAnswer, index) => {
			var value = dataAnswer[valueProperty];
			if (valuesToHide.indexOf(value) !== -1) {
				return;
			}

			var answerModel = {};

			if (displayValueProperty.indexOf("$") !== -1) {
				answerModel.displayValue = displayValueProperty.replace(/\${(.*?)}/g, (match, submatch) => dataAnswer[submatch]);
			} else {
				answerModel.displayValue = dataAnswer[displayValueProperty];
			}

			if (labelKey) {
				answerModel.label = dataAnswer[labelKey];
			}

			answerModel.value = value;
			answers.push(answerModel);
		});

		if (displayAlphabetical) {
			answers.sort((a, b) => {
				var value1 = ((a && (a.displayValue || a.value)) || "").toLowerCase();
				var value2 = ((b && (b.displayValue || b.value)) || "").toLowerCase();

				if (value1 === value2) {
					return 0;
				}

				return (value1 < value2) ? -1 : 1;
			});
		}

		questionDefinition.answers = answers;
		callback();
	});
};

var fetchIsVisibleForQuestions = function (questions, currentCount, model, callback) {
	questions.forEach(questionDefinition => {
		//If this is really a row of questions
		if (questionDefinition.row && questionDefinition.row.questions) {
			currentCount = fetchIsVisibleForQuestions(questionDefinition.row.questions, currentCount, model, callback);
			return;
		}

		//Otherwise fetch Is Visible for Questions
		if (questionDefinition.visible && typeof questionDefinition.visible === "object") {
			++currentCount;
			fetchIsVisible(questionDefinition, model, callback);
		} else if (Array.isArray(questionDefinition.answers)) {
			questionDefinition.answers.forEach(answerDefinition => {
				if (answerDefinition.questions) {
					currentCount = fetchIsVisibleForQuestions(answerDefinition.questions, currentCount, model, callback);
				}
			});
		}
	});

	return currentCount;
}

var fetchIsVisible = function (questionDefinition, model, callback) {
	var visibleObject = questionDefinition.visible;
	var url = visibleObject.url;
	var field = visibleObject.field;
	var value = visibleObject.value;
	//If you ever need to put a token in the URL, you can mirror what fetch answers is doing.'
	$.get(url, (data) => {
		//If the field on the data we get back from the API call matches our value, we are visible
		if (data && data[field] === value) {
			//So we can remove the visible property
			delete questionDefinition.visible;
		} else {
			//Otherwise, we need to set visible to false
			questionDefinition.visible = false;
		}
		callback();
	});
};

var processCollapseDescriptionData = function(data, valueProperty, descriptionAppendKey) {
	descriptionAppendKey = descriptionAppendKey || "";
	//Getting values (that have forEachDescriptions) from another wizard answer
	//	data can be a string or an object
	if (data) {
		if (typeof data === "string") {
			data = JSON.parse(data);
		}
		var array = data[valueProperty];
		if (Array.isArray(array)) {
			data = array.map(arrayValue => {
				return {
					value: arrayValue,
					description: data[`${descriptionAppendKey}${arrayValue}_Description`]
				};
			});
		} else {
			data = [];
		}
	} else {
		data = [];
	}

	return data;
};

var beginFetchAnswers = function (model, questions, savedModel, stateValues, callback) {
	var totalCount;
	var returnedCount = 0;
	var needToFetch = needToFetchAnswers(questions);
	var checkIfVisible = needToCheckIfVisible(questions);
	if (needToFetch || checkIfVisible) {
		questions.forEach(question => {
			question.fetching = true;
		});

		var fetchReturnCallback = function() {
			++returnedCount;
			if (totalCount && returnedCount === totalCount) {
				questions.forEach(question => {
					question.fetching = false;
				});

				// Set the value at any level for defaultAnswer/savedModel
				setAnswerNested(model, questions, savedModel, stateValues, callback);
				if ((typeof callback === "function")) {
					callback();
				}
			}
		};

		if (needToFetch) {
			totalCount = fetchAnswersForQuestions(questions, 0, model, fetchReturnCallback);
		}

		if (checkIfVisible) {
			totalCount = totalCount + fetchIsVisibleForQuestions(questions, 0, model, fetchReturnCallback);
		}
	} else {
		// Set the value at any level for defaultAnswer/savedModel
		setAnswerNested(model, questions, savedModel, stateValues, callback);
		if ((typeof callback === "function")) {
			callback();
		}
	}
};

var setDynamicQuestionProperty = function (model, questions) {
	if (!questions) {
		return;
	}

	questions.forEach(question => {
		if (question.row && question.row.questions) {
			setDynamicQuestionProperty(model, question.row.questions);
		} else {
			question.property = question.originalProperty || question.property;

			while (question.property.indexOf("{") >= 0) {
				//Replacing a questionDefinition property that looks like this "{selectedCountry}" with the selectedCountry that was set on the model from a previous question
				question.originalProperty = question.property;
				question.property = RegExpHelper.replaceFirstBraceTokenFromObject(question.property, model);
			}
		}
	});
};

class Wizard extends React.Component {
	constructor(props) {
		super(props);

		var model = {};

		if (props.initializeModelFromSavedModel && props.savedModel) {
			model = props.savedModel;
		}

		this.state = {
			additionalPageNumber: 0,
			additionalPages: props.additionalPages,
			allowPartialSave: props.allowPartialSave,
			paragraph: props.paragraph,
			questions: props.questions,
			model,
			loading: true,
			loadingInactiveValues: false,
			canSubmit: props.canSubmit,
			canCancel: props.canCancel,
			submitText: props.submitText,
			cancelText: props.cancelText,
			emptyRequiredFieldsErrorMessage: null,
			invalidInputFieldPatternErrorMessage: null,
			isDelayOpen: props.isDelayOpen || false,
			fieldValidationErrors: {} // Track validation errors per field
		};

		// Store original values for resetting when answers change
		this.originalSubmitText = props.submitText;
		this.originalCancelText = props.cancelText;
	}

	setValue(questionDefinition, propertyName, values) {
		var possibleAnswers = questionDefinition.answers;
		var model = this.state.model;
		var stateValues = {
			submitText: this.originalSubmitText, // Reset to original, will be overridden if answer has custom submitText
			cancelText: this.originalCancelText, // Reset to original, will be overridden if answer has custom cancelText
			canSubmit: this.state.canSubmit,
			canCancel: this.state.canCancel,
			additionalPages: null,
			additionalPageNumber: 0
		};
		var selectedAnswers = [];
		var nonSelectedAnswers = [];
		possibleAnswers.forEach(answer => {
			// Use == for coercion, values are coming from option.value, always a string but our answers can be other types
			if (values.find(value => value == answer.value)) {
				selectedAnswers.push(answer);
			} else {
				nonSelectedAnswers.push(answer);
			}
		});

		// Clear the value at any level
		if (!questionDefinition.doNotClearNestedAnswers) {
			clearAnswersNested(model, nonSelectedAnswers);
		}

		if (questionDefinition.multiple) {
			model[propertyName] = [];
		} else {
			delete model[propertyName];
		}

		selectedAnswers.sort((a, b) => values.indexOf(a.value) < values.indexOf(b.value) ? -1 : 1);
		selectedAnswers.forEach(selectedAnswer => {
			var value = selectedAnswer.value;

			if (questionDefinition.multiple) {
				model[propertyName].push(value);
			} else {
				model[propertyName] = value;
			}

			if (selectedAnswer.submitText) {
				stateValues.submitText = selectedAnswer.submitText;
			}
			if (selectedAnswer.cancelText) {
				stateValues.cancelText = selectedAnswer.cancelText;
			}
			if (selectedAnswer.hasOwnProperty("canSubmit")) {
				stateValues.canSubmit = selectedAnswer.canSubmit;
			}
			if (selectedAnswer.hasOwnProperty("canCancel")) {
				stateValues.canCancel = selectedAnswer.canCancel;
			}

			// Handle additionalPages from selected answers
			if (selectedAnswer.additionalPages) {
				stateValues.additionalPages = selectedAnswer.additionalPages;
				stateValues.additionalPageNumber = 0;
			}

			processDynamicQuestions(questionDefinition, selectedAnswer);

			// Set the value at any level for defaultAnswer/savedModel
			setDynamicQuestionProperty(model, selectedAnswer.questions);
			beginFetchAnswers(model, selectedAnswer.questions, this.props.savedModel, stateValues, () => {
				this.setState(stateValues);
			});
		});

		stateValues.model = model;
		this.setState(stateValues, () => {
			if (this.state.fieldValidationErrors[propertyName] && this.state.fieldValidationErrors[propertyName].length > 0) {
				this.validateAndUpdateFieldState(questionDefinition, propertyName);
			}
			// Validate any fields with custom JavaScript validation since they might depend on changed field values
			this.validateAllFields(this.state.questions, /*onlyRunForFieldsWithCustomValidation*/ true);
			if (this.state.emptyRequiredFieldsErrorMessage) {
				this.hasEmptyRequiredFields(this.state.questions);
			}
		});
	}

	getEmptyRequiredFields(currentQuestions) {
		if (!currentQuestions) {
			return [];
		}

		var fieldNames = [];

		currentQuestions.forEach(eachQuestion => {
			//If the question is not visible return
			if(eachQuestion.visible === false) {
				return;
			}

			var isQuestionRequired = eachQuestion.required;
			var allowSpaces = eachQuestion.allowSpaces;
			var questionAnswer = this.state.model[eachQuestion.property];
			var isAnswerEmpty = questionAnswer === undefined ||
				questionAnswer === null ||
				(typeof questionAnswer === "string" && (allowSpaces ? questionAnswer : questionAnswer.trim()) === "") ||
				(eachQuestion.type === "checkbox" && !questionAnswer);

			// If we're required and don't have a value we need to push onto the stack and return
			// because we don't care about child questions until it's answered
			if (isQuestionRequired && isAnswerEmpty) {
				fieldNames = fieldNames.concat( eachQuestion.property );
				return;
			}

			// If it's required, we need to check to see if any below it are also required.
			// But we only want to check based on the selected answer
			if (eachQuestion.row && eachQuestion.row.questions) {
				fieldNames = fieldNames.concat(this.getEmptyRequiredFields(eachQuestion.row.questions, fieldNames));
			} else if (eachQuestion.answers) {
				eachQuestion.answers.forEach(eachQuestionAnswer => {
					if (eachQuestionAnswer.value === questionAnswer && eachQuestionAnswer.questions) {
						fieldNames = fieldNames.concat(this.getEmptyRequiredFields(eachQuestionAnswer.questions, fieldNames));
					}
				});
			}
		});

		return fieldNames;
	}

	hasEmptyRequiredFields(questions) {
		var emptyRequiredFields = this.getEmptyRequiredFields(questions);
		if (emptyRequiredFields.length) {
			var message = `Unable to save, the following required fields are empty: [${emptyRequiredFields.join(", ")}]`;
			LoggerInstance.error(message);

			this.setState({
				emptyRequiredFieldsErrorMessage: message
			});
		} else {
			this.setState({
				emptyRequiredFieldsErrorMessage: null
			});
		}

		return emptyRequiredFields.length > 0;
	}

	getInvalidInputFieldPattern(questions) {
		if (!questions) {
			return [];
		}

		var invalidMessages = [];

		questions.forEach(question => {
			if (question.row && question.row.questions) {
				invalidMessages = invalidMessages.concat(this.getInvalidInputFieldPattern(question.row.questions));
			} else if (question.property) {
				// Use the existing validateSingleField method but exclude required field validation
				// since that's handled separately by hasEmptyRequiredFields
				var fieldErrors = this.validateSingleField(question, question.property, /*includeRequiredValidation*/ false);
				invalidMessages = invalidMessages.concat(fieldErrors);
			}
		});

		return invalidMessages;
	}

	hasInvalidInputFieldPattern(questions) {
		var invalidMessages = this.getInvalidInputFieldPattern(questions);

		if (invalidMessages.length) {
			var message = `Unable to save. There are invalid fields:\n${invalidMessages.join("\n")}`;
			LoggerInstance.error(message);

			this.setState({
				invalidInputFieldPatternErrorMessage: message
			});
		}
		else {
			this.setState({
				invalidInputFieldPatternErrorMessage: null
			});
		}

		return invalidMessages.length > 0;
	}

	validateSingleField(question, propertyName, includeRequiredValidation = true) {
		var questionAnswer = this.state.model[propertyName];
		var allowSpaces = question.allowSpaces;
		var isAnswerEmpty = questionAnswer === undefined ||
			questionAnswer === null ||
			(typeof questionAnswer === "string" && (allowSpaces ? questionAnswer : questionAnswer.trim()) === "") ||
			(question.type === "checkbox" && !questionAnswer);

		var invalidMessages = [];

		// Required field validation (only if includeRequiredValidation is true)
		if (includeRequiredValidation && question.required && isAnswerEmpty) {
			invalidMessages.push(`${question.question || propertyName} is required`);
		}

		if (!isAnswerEmpty) {
			// Pattern validation
			if (question.pattern) {
				var regex = new RegExp(question.pattern);
				if (!regex.test(questionAnswer)) {
					invalidMessages.push(question.invalidMessage || `${question.question || propertyName} is invalid`);
				}
			}

			// Number validation
			if (question.type === "number") {
				var numericValue = parseFloat(questionAnswer);
				if (!isNaN(numericValue)) {
					if (question.minValue !== undefined && numericValue < question.minValue) {
						var minMessage = question.minValueMessage || `Value must be at least ${question.minValue}`;
						invalidMessages.push(minMessage);
					}
					if (question.maxValue !== undefined && numericValue > question.maxValue) {
						var maxMessage = question.maxValueMessage || `Value must be no more than ${question.maxValue}`;
						invalidMessages.push(maxMessage);
					}

					// Step validation
					if (question.step !== undefined && question.step > 0) {
						var minValue = question.minValue || 0;
						var remainder = (numericValue - minValue) % question.step;
						var epsilon = 0.0001;
						if (Math.abs(remainder) > epsilon && Math.abs(remainder - question.step) > epsilon) {
							var stepMessage = question.stepMessage || `Value must be in increments of ${question.step}`;
							if (question.step === 1) {
								stepMessage = question.stepMessage || "Value must be a whole number";
							}
							invalidMessages.push(stepMessage);
						}
					}
				}
			}

			// Custom JavaScript validation
			if (question.customJavascriptIsValid) {
				try {
					var validationFunction = new Function('value', 'model', 'questionDefinition', question.customJavascriptIsValid);
					var validationResult = validationFunction(questionAnswer, this.state.model, question);

					if (validationResult === false) {
						var customMessage = question.customValidationMessage || "Invalid value";
						invalidMessages.push(customMessage);
					} else if (typeof validationResult === "string") {
						invalidMessages.push(validationResult);
					} else if (validationResult && typeof validationResult === "object" && validationResult.isValid === false) {
						var objMessage = validationResult.message || question.customValidationMessage || "Invalid value";
						invalidMessages.push(objMessage);
					}
				} catch (error) {
					LoggerInstance.error("Custom validation error for question " + question.property, error);
					invalidMessages.push("Validation error occurred");
				}
			}
		}

		return invalidMessages;
	}

	validateAndUpdateFieldState(question, propertyName) {
		var errors = this.validateSingleField(question, propertyName);
		var fieldValidationErrors = this.state.fieldValidationErrors;

		if (errors.length > 0) {
			fieldValidationErrors[propertyName] = errors;
		} else {
			delete fieldValidationErrors[propertyName];
		}

		this.setState({
			fieldValidationErrors: fieldValidationErrors
		});
	}

	hasValidationErrors() {
		return Object.keys(this.state.fieldValidationErrors).length > 0;
	}

	getFormattedValidationErrors() {
		var errors = [];
		var fieldErrors = this.state.fieldValidationErrors;
		var seenErrors = {}; // To avoid duplicate error messages shown to user

		for (var propertyName in fieldErrors) {
			if (fieldErrors.hasOwnProperty(propertyName) && fieldErrors[propertyName].length > 0) {
				fieldErrors[propertyName].forEach(error => {
					// Only add the error if we haven't seen this exact message before for a different field
					if (!seenErrors[error]) {
						seenErrors[error] = true;
						errors.push(error);
					}
				});
			}
		}

		return errors;
	}

	validateAllFields(questions, onlyRunForFieldsWithCustomValidation = false) {
		if (!questions) {
			return;
		}

		questions.forEach(question => {
			if (question.row && question.row.questions) {
				// Recursive call here to handle the case that there are nested questions based on answers
				this.validateAllFields(question.row.questions, onlyRunForFieldsWithCustomValidation);
			} else if (question.property && (onlyRunForFieldsWithCustomValidation ? question.customJavascriptIsValid : true)) {
				this.validateAndUpdateFieldState(question, question.property);
			}
		});
	}

	handleSelectPropertyChange(questionDefinition, propertyName, event) {
		var values = [...event.target.options].filter(option => option.selected).map(option => option.value);
		this.setValue(questionDefinition, propertyName, values);
	}

	handleSelectSetValue(questionDefinition, propertyName, value) {
		if (!!questionDefinition.multiple !== Array.isArray(value)) {
			LoggerInstance.error("Value should only be array if question supports multiple values.");
		}

		var values = [];
		if (Array.isArray(value)) {
			values = value.map(option => option.value);
		} else if (!value) {
			values = [];
		} else {
			values = [value.value];
		}
		this.setValue(questionDefinition, propertyName, values);
	}

	handlePropertyBlur(questionDefinition, propertyName, event) {
		// Validate the field when user leaves it
		this.validateAndUpdateFieldState(questionDefinition, propertyName);
	}

	handlePropertyChange(questionDefinition, propertyName, event) {
		var model = this.state.model;
		var value = event.target.type === "checkbox" ? event.target.checked : event.target.value;

		if (event.target.type !== "checkbox" && questionDefinition.allCaps === true && value) {
			value = value.toUpperCase();
		}

		// We need to encode this value if it's a LongDescription
		if (value && propertyName.indexOf("_LongDescription") >= 0) {
			value = encodeURIComponent(value);
		}

		// If a positive number is required, force the number entered to be positive and don't raise an error
		if (event.target.type === "number" && questionDefinition.requirePositive) {
			if (value != null && value !== 0 && !isNaN(value)) {
				value = Math.abs(value);
			}
			if (value === 0) {
				value = null;
			}
		}

		model[propertyName] = value;
		if ((typeof questionDefinition.onChange === "function")) {
			questionDefinition.onChange(model);
		}
		else if (questionDefinition.onChangeIfTrue && model[propertyName]) {
			//Currently this is used to be able to do the Default Message Checkbox, setting text box back to default value
			for (var propertyToChange in questionDefinition.onChangeIfTrue) {

				if (questionDefinition.onChangeIfTrue.hasOwnProperty(propertyToChange)) {
					var finalizedPropertyToChange = this.performPropertyReplacement(propertyToChange, model);
					model[finalizedPropertyToChange] = questionDefinition.onChangeIfTrue[propertyToChange];
				}
			}
		}

		this.setState({ model }, () => {
			if (this.state.fieldValidationErrors[propertyName] && this.state.fieldValidationErrors[propertyName].length > 0) {
				this.validateAndUpdateFieldState(questionDefinition, propertyName);
			}
			// Also validate any fields with custom JavaScript validation since they might depend on this field's value
			this.validateAllFields(this.state.questions, /*onlyRunForFieldsWithCustomValidation*/ true);
			if (this.state.emptyRequiredFieldsErrorMessage) {
				this.hasEmptyRequiredFields(this.state.questions);
			}
		});
	}

	performPropertyReplacement(text, model) {
		while (text.indexOf("{") >= 0) {
			//Replaces any occurrence of {propertyName} in 'text' with the current value of 'model[propertyName]'.
			text = RegExpHelper.replaceFirstBraceTokenFromObject(text, model);
		}

		return text;
	}

	handleSaveClick() {
		// First, validate all fields individually to update visual state
		this.validateAllFields(this.state.questions);

		var hasEmptyRequiredFields = this.hasEmptyRequiredFields(this.state.questions);
		var hasInvalidInputFieldPattern = this.hasInvalidInputFieldPattern(this.state.questions);

		if (!hasEmptyRequiredFields && !hasInvalidInputFieldPattern)
		{
			// Clear all field validation errors on successful validation
			this.setState({ fieldValidationErrors: {} });

			var additionalPages = this.state.additionalPages;
			var additionalPageNumber = this.state.additionalPageNumber;
			var stateValues = {
				loading: false
			};

			//Check if this wizard has additional pages it needs to show before saving
			if(additionalPages && additionalPages.length > additionalPageNumber) {
				//If so, get the page, set the details into state and then begin fetching answers
				var newPage = additionalPages[additionalPageNumber];
				this.setState({
					paragraph: newPage.paragraph,
					questions: newPage.questions,
					submitText: newPage.submitText,
					cancelText: newPage.cancelText,
					additionalPageNumber: additionalPageNumber + 1,
					loading: true
				}, () => {
					beginFetchAnswers(this.state.model, this.state.questions, this.props.savedModel, stateValues, () => {
						this.setState(stateValues, () => {
							// Validate all fields on the new additional page after it loads
							this.validateAllFields(this.state.questions, /*onlyRunForFieldsWithCustomValidation*/ true);
						});
					});
				});
				return;
			}

			//Removing properties that should not be saved
			this.state.doNotSaveProperties.forEach(property => {
				delete this.state.model[property];
			});

			this.props.onSave(this.state.model);
		}
	}

	handleSavePartialClick() {
		this.props.onSave(this.state.model, /*isPartialSave*/ true);
	}

	handleCancelClick() {
		this.props.onCancel();
	}

	handleDragStart(event) {
		event.dataTransfer.dropEffect = "move";
		var $dragElement = $(event.target);

		$dragElement.addClass("orderedSelectSource");
	}

	handleDragOver(event) {
		event.preventDefault();
		var $parent = $(ReactDOM.findDOMNode(this));
		var $dropTarget = $(event.target);
		var $orderedSelectSource = $parent.find(".orderedSelectSource");
		$orderedSelectSource.hide();

		var $parent = $(ReactDOM.findDOMNode(this));
		var isSelectedList = false;
		if ($dropTarget.closest(".selected").length > 0) {
			isSelectedList = true;
			$parent.find(".nonSelected .orderedSelectPlaceholder").remove();
		} else {
			$parent.find(".selected .orderedSelectPlaceholder").remove();
		}

		var placeholder = "<li class='orderedSelectPlaceholder'></li>";
		var hasPlaceholder = $parent.find(".orderedSelectPlaceholder").length > 0;
		if ($dropTarget.is("li:not(.orderedSelectPlaceholder)")) {
			var isBefore = false;
			if (hasPlaceholder) {
				isBefore = $dropTarget.prev().is(".orderedSelectPlaceholder");
				$parent.find(".orderedSelectPlaceholder").remove();
			}
			if (isBefore) {
				$dropTarget.after(placeholder);
			} else {
				$dropTarget.before(placeholder);
			}
		} else if ($dropTarget.is(".orderedSelect") && $dropTarget.find("li").length === 0 && !hasPlaceholder) {
			$dropTarget.append(placeholder);
		}

		return false;
	}

	handleDragEnd(event) {
		event.stopPropagation();
		var $parent = $(ReactDOM.findDOMNode(this));
		var $orderedSelectSource = $parent.find(".orderedSelectSource");

		// Cleanup
		$orderedSelectSource.removeClass("orderedSelectSource");
		$orderedSelectSource.show();
		$parent.find(".orderedSelectPlaceholder").remove();
	}

	handleDrop(questionDefinition, selectedAnswers, event) {
		event.stopPropagation();
		var $dropTarget = $(event.target);
		var $parent = $(ReactDOM.findDOMNode(this));
		var isSelectedList = false;
		var propertyName = questionDefinition.property;
		var values = selectedAnswers.map(answer => answer.value);
		var $orderedSelectSource = $parent.find(".orderedSelectSource");
		var $placeholder = $parent.find(".orderedSelectPlaceholder");
		var changedAnswer = questionDefinition.answers.find(answer => answer.value == $orderedSelectSource.attr("data-value"));
		var selectedValue = changedAnswer.value;
		var existingIndex = values.indexOf(changedAnswer.value);

		if ($dropTarget.closest(".selected").length > 0) {
			isSelectedList = true;
		}

		if (isSelectedList) {
			//We cannot use "$.escapeSelector()" until we upgrade to jQuery 3.0
			//CSS.escape is does not work in IE; this is Ok, as wizard is admin.
			var desiredIndex = $dropTarget.closest(".selected").find(`li:not([data-value="${CSS.escape(selectedValue)}"])`).index($placeholder);
			if (existingIndex !== -1) {
				values.splice(existingIndex, 1);
			}
			values.splice(desiredIndex, 0, selectedValue);
		} else {
			if (existingIndex !== -1) {
				values.splice(existingIndex, 1);
			} else {
				// TODO: should we support ordering the non-selected list?
			}
		}

		// Cleanup
		$orderedSelectSource.show();
		$orderedSelectSource.removeClass("orderedSelectSource");
		$placeholder.remove();

		this.setValue(questionDefinition, propertyName, values);

		return false;
	}

	initialBeginFetchAnswers() {
		// Modifies the state
		var stateValues = {
			canCancel: this.state.canCancel,
			canSubmit: this.state.canSubmit,
			cancelText: this.state.cancelText,
			doNotSaveProperties: [],
			loading: this.state.isDelayOpen,
			loadingInactiveValues: this.state.questions && this.state.questions.some(question => question.mustIncludeSelectedAnswer),
			submitText: this.state.submitText
		};
		beginFetchAnswers(this.state.model, this.state.questions, this.props.savedModel, stateValues, () => {
			this.setState(stateValues, () => {
				// Validate all fields after initial data is loaded
				this.validateAllFields(this.state.questions, /*onlyRunForFieldsWithCustomValidation*/ true);
			});
		});
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	componentDidMount() {
		if ((typeof this.props.onInitialLoadData === "function")) {
			//We are going to call this function.  Currently the main purpose of this is to make an API call to see which wizard screen should be shown first
			this.props.onInitialLoadData().done((newProps) => {
				//If it has new props, this means that the wizard is changing, so set those props in state, like we are doing in the constructor
				if (this._isMounted && newProps) {
					var newState = {};
					if (newProps.initializeModelFromSavedModel && newProps.savedModel) {
						newState.model = newProps.savedModel;
					}
					newState.additionalPages = newProps.additionalPages;
					newState.allowPartialSave = newProps.allowPartialSave;
					newState.paragraph = newProps.paragraph;
					newState.questions = newProps.questions;
					newState.additionalPages = newProps.additionalPages;
					newState.loading = true;
					newState.canSubmit = newProps.canSubmit === false ? false : true;
					newState.canCancel = newProps.canCancel === false ? false : true;
					newState.submitText = newProps.submitText;
					newState.cancelText = newProps.cancelText;
					if (newState.additionalPages) {
						newState.additionalPageNumber = 0;
					}
					newState.isDelayOpen = false;

					// Update original values when new props are loaded
					this.originalSubmitText = newProps.submitText;
					this.originalCancelText = newProps.cancelText;

					this.setState(newState, () => {
						if (newProps) {
							this.initialBeginFetchAnswers();
						}
					});
				}
			}).always(() => {
				if (this._isMounted) {
					this.forceUpdate();
				}
			});
		}

		this._isMounted = true;

		this.initialBeginFetchAnswers();
	}

	renderOrderedSelect(questionDefinition, selectedAnswers, nonSelectedAnswers) {
		return (
			<div className="row" onDragStart={this.handleDragStart.bind(this)} onDragEnd={this.handleDragEnd.bind(this)} onDrop={this.handleDrop.bind(this, questionDefinition, selectedAnswers)}>
				{!questionDefinition.hideAdd &&
					<div className="nonSelected col-xs-6">
						<ul className="orderedSelect" onDragOver={this.handleDragOver.bind(this)}>
							{nonSelectedAnswers.map(nonSelectedAnswer => {
								return (
									<li
										key={nonSelectedAnswer.value}
										data-value={nonSelectedAnswer.value}
										draggable="true"
									>
										{nonSelectedAnswer.displayValue}
									</li>
								);
							})}
						</ul>
					</div>
				}
				<div className={`selected col-xs-${questionDefinition.hideAdd ? "12" : "6"}`}>
					<ul className="orderedSelect" onDragOver={this.handleDragOver.bind(this)}>
						{selectedAnswers.map(selectedAnswer => {
							return (
								<li key={selectedAnswer.value}
									data-value={selectedAnswer.value}
									draggable="true"
								>
									{selectedAnswer.displayValue}
								</li>
							);
						})}
					</ul>
				</div>
			</div>
		);
	}

	ensureAnswersAreObjects(answers) {
		if (!answers || !Array.isArray(answers)) {
			return answers;
		}

		var convertedAnswers = [];
		answers.forEach(answer => {
			if (typeof answer !== "object") {
				convertedAnswers.push({ value: answer, displayValue: answer });
			} else {
				convertedAnswers.push(answer);
			}
		});

		return convertedAnswers;
	}

	renderSelect(questionDefinition, propertyName) {
		var hasGroups = questionDefinition.answers.some(answer => answer.isGroup);
		var multiple = questionDefinition.multiple;
		var ordering = questionDefinition.order && multiple;
		var searchable = questionDefinition.searchable;
		var labelKey = questionDefinition.labelKey;
		var value = this.state.model[propertyName];
		if (!value && value !== 0) {
			value = multiple ? [] : "";
		}
		var answers = [];
		var selectedAnswers = [];
		var nonSelectedAnswers = [];

		questionDefinition.answers = this.ensureAnswersAreObjects(questionDefinition.answers);

		if (multiple) {
			questionDefinition.answers.forEach(answer => {
				if (value.find(val => val == answer.value)) {
					selectedAnswers.push(answer);
				} else {
					nonSelectedAnswers.push(answer);
				}
			});
			selectedAnswers.sort((a, b) => value.indexOf(a.value) < value.indexOf(b.value) ? -1 : 1);
		} else if (value) {
			var answer = questionDefinition.answers.find(answer => answer.value == value);
			if (answer) {
				selectedAnswers.push(answer);
			}
		}

		if (hasGroups) {
			var group = null;
			questionDefinition.answers.forEach(answer => {
				if (answer.isGroup) {
					group = { label: answer.displayValue || answer.value, answers: [] };
					answers.push(group);
				} else {
					group.answers.push(answer);
				}
			});
		} else {
			answers = questionDefinition.answers;
		}

		if (hasGroups && questionDefinition.order) {
			LoggerInstance.error("Option groups are not supported with ordering.");
		}
		if (questionDefinition.order && !multiple) {
			LoggerInstance.error("Ordering is only supported with multiple select.");
		}

		var selectToRender;
		if (ordering) {
			selectToRender = this.renderOrderedSelect(questionDefinition, selectedAnswers, nonSelectedAnswers);
		} else if (searchable) {
			selectToRender = (
				<Select
					hasValueDescriptionOptions={!!labelKey}
					isMulti={multiple}
					getOptionLabel={option => option.displayValue}
					getOptionValue={option => option.value}
					value={answers.filter(option => option.value === value)}
					options={answers}
					onChange={this.handleSelectSetValue.bind(this, questionDefinition, propertyName)}
				/>
			);
		} else {
			selectToRender = (
				<select
						className="form-control"
						data-property={propertyName}
						onChange={this.handleSelectPropertyChange.bind(this, questionDefinition, propertyName)}
						disabled={questionDefinition.disabled}
						multiple={multiple}
						size={multiple ? Math.min(questionDefinition.answers.length, 10) : undefined}
						value={value}
				>
					{!multiple && !questionDefinition.disallowNull && <option /> }
					{hasGroups ?
						answers.map(group => {
							return (
								<optgroup label={group.label} key={group.label}>
									{group.answers.map(answer => {
										return (
											<option value={answer.value} key={answer.value}>{answer.displayValue || answer.value}</option>
										);
									})}
								</optgroup>
							);
						})
					:
						answers.map(answer => {
							return (
								<option value={answer.value} key={answer.value}>{answer.displayValue || answer.value}</option>
							);
						})
					}
				</select>
			);
		}

		return (
			<div>
				{selectToRender}
				{selectedAnswers && !questionDefinition.hideDescriptions &&
					selectedAnswers.map(selectedAnswer => {
						if (!selectedAnswer.questions) {
							return null;
						}

						return (
							<div className={selectedAnswer.className} key={selectedAnswer.value}>
								{selectedAnswer.questions.map((subQuestionDefinition, index) => {
									return this.renderQuestion(subQuestionDefinition, index);
								})}
							</div>
						);
					})
				}
			</div>
		);
	}

	renderQuestion(questionDefinition, index, isTopLevel) {
		//This allows us to break questions up into rows
		if (questionDefinition.row && questionDefinition.row.questions) {
			return (
				<div className="row" key={index}>
					{(isTopLevel && index > 0 && !questionDefinition.hideHorizontalRule) && <hr/>}
					{
						questionDefinition.row.questions.map((rowQuestionDefinition, index) => {
							return this.renderQuestion(rowQuestionDefinition, index);
						})
					}
				</div>
			);
		}

		if (questionDefinition.visible === false) {
			return null;
		}

		//Rendering the actual question itself
		var propertyName = questionDefinition.property;

		if (questionDefinition.fetching) {
			return (
				<div key={`${propertyName}_loading`} className="spinner" style={{ minHeight: "200px", maxHeight: "500px", height: "unset" }}>
					<i className="fa fa-spinner fa-spin"></i>
				</div>
			);
		}

		if (questionDefinition.labelText && questionDefinition.answers) {
			LoggerInstance.error("Label is only supported with text input.");
		}

		var disabled = false;
		if ((typeof questionDefinition.disabled === "function")) {
			disabled = questionDefinition.disabled(this.state.model);
		} else if (typeof questionDefinition.disabled === "string") {
			var disabledValue = this.performPropertyReplacement(questionDefinition.disabled, this.state.model)
			disabled = !!this.state.model[disabledValue];
		}

		var propertyValue = this.state.model[propertyName];

		return (
			<div key={propertyName} className={questionDefinition.className}>
				{(isTopLevel && index > 0 && !questionDefinition.hideHorizontalRule) && <hr />}
				<div className="wizardQuestion">
					<span>{questionDefinition.question}</span>
					{questionDefinition.paragraph && Wizard.renderWizardParagraph(questionDefinition.paragraph, /*isQuestionParagraph*/ true)}
				</div>
				{questionDefinition.answers ?
					this.renderSelect(questionDefinition, propertyName)
				:
					<div className="wizardQuestionSimple">
						{questionDefinition.labelText &&
							<label className="wizardQuestionLabel">{questionDefinition.labelText}</label>
						}
						{questionDefinition.type === "checkbox" &&
							<input
								id={propertyName}
								data-property={propertyName}
								type="checkbox"
								checked={propertyValue || false}
								onChange={this.handlePropertyChange.bind(this, questionDefinition, propertyName)}
							/>
						}
						{questionDefinition.type === "textarea" &&
							<textarea
								id={propertyName}
								className={classnames("form-control", disabled)}
								data-property={propertyName}
								type="text"
								value={propertyValue || ""}
								onChange={this.handlePropertyChange.bind(this, questionDefinition, propertyName)}
								placeholder={questionDefinition.placeholder}
								disabled={disabled}
								maxLength={questionDefinition.maxLength}
							/>
						}
						{questionDefinition.type === "number" &&
							<input
								id={propertyName}
								className={classnames("form-control", disabled, { 
										"invalid": this.state.fieldValidationErrors[propertyName]
								})}
								data-property={propertyName}
								type="number"
								value={(!propertyValue && propertyValue !== 0) ? "" : propertyValue}
								onChange={this.handlePropertyChange.bind(this, questionDefinition, propertyName)}
								onBlur={this.handlePropertyBlur.bind(this, questionDefinition, propertyName)}
								placeholder={questionDefinition.placeholder}
								disabled={disabled}
								maxLength={questionDefinition.maxLength}
								min={questionDefinition.minValue}
								max={questionDefinition.maxValue}
								step={questionDefinition.step}
							/>
						}
						{(questionDefinition.type !== "checkbox" && questionDefinition.type !== "textarea" && questionDefinition.type !== "number" && questionDefinition.type !== "none") &&
							<input
								id={propertyName}
								className={classnames("form-control", disabled)}
								data-property={propertyName}
								type="text"
								value={propertyValue && propertyName.indexOf("_LongDescription") > -1 ? decodeURIComponent(propertyValue) : propertyValue || ""}
								onChange={this.handlePropertyChange.bind(this, questionDefinition, propertyName)}
								placeholder={questionDefinition.placeholder}
								disabled={disabled}
								maxLength={questionDefinition.maxLength}
								pattern={questionDefinition.pattern}
							/>
						}
					</div>
				}
			</div>
		);
	}

	render() {
		if (this.state.loading || this.state.loadingInactiveValues) {
			return (
				<div className="spinner" style={{ minHeight: "200px", maxHeight: "500px", height: "unset" }}>
					<i className="fa fa-spinner fa-spin"></i>
				</div>
			);
		}

		var disableSubmit = !this.state.canSubmit || this.hasValidationErrors();
		var disableCancel = !this.state.canCancel;

		return (
			<div className={classnames("wizard")}>
				{this.state.paragraph &&
					Wizard.renderWizardParagraph(this.state.paragraph)
				}
				{this.state.questions &&
					this.state.questions.map((questionDefinition, index) => {
						return this.renderQuestion(questionDefinition, index, true);
					})
				}
				{this.state.emptyRequiredFieldsErrorMessage &&
					<div className="save-error-message alert alert-danger">{this.state.emptyRequiredFieldsErrorMessage}</div>
				}
				{this.state.invalidInputFieldPatternErrorMessage &&
					<div className="save-error-message alert alert-danger" style={{ "whiteSpace": "pre-wrap" }}>{this.state.invalidInputFieldPatternErrorMessage}</div>
				}
				{this.hasValidationErrors() &&
					<div className="save-error-message alert alert-danger">
						<ul className="mb-0 mt-2">
							{this.getFormattedValidationErrors().map((error, index) => (
								<li key={index}>{error}</li>
							))}
						</ul>
					</div>
				}
				<div className="wizardFooter">
					<button className="btn btn-success" onClick={this.handleSaveClick.bind(this)} disabled={disableSubmit}>{this.state.submitText}</button>
					{this.state.allowPartialSave &&
						<button className="btn btn-success" onClick={this.handleSavePartialClick.bind(this)} disabled={disableSubmit}>Save as Draft</button>
					}
					{(!disableCancel || !this.props.dialog.defaultOptions.hasOwnProperty("closable") || this.props.dialog.defaultOptions.closable) &&
						<button className="btn btn-default" onClick={this.handleCancelClick.bind(this)} disabled={disableCancel}>{this.state.cancelText || "Cancel"}</button>
					}
				</div>
			</div>
		);
	}
}

Wizard.defaultProps = {};

Wizard.renderWizardParagraph = (paragraph, isQuestionParagraph = false) => {
	if (!paragraph) {
		return null;
	}

	if (typeof paragraph === "string") {
		return <p className={classnames(isQuestionParagraph ? "wizardQuestionTip" : "wizardTip")}>{paragraph}</p>
	}

	if (typeof paragraph === "object") {
		return <div className={classnames(isQuestionParagraph ? "wizardQuestionTip" : "wizardTip")} dangerouslySetInnerHTML={paragraph} />
	}

	return null;
};

module.exports = Wizard;
